// libs
import React, { Suspense } from "react";
import { RouterProvider } from "react-router-dom";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";

// AG-Grid enterprise setup
import "@utils/agGridModules";

// routes
import { getRouter } from "./router";

// components
import { LinearLoader } from "@components/Loader";

// providers
import { AppProvider } from "@store/context/App";
import { UserInfoProvider } from "@store/context/UserInfo";

const App: React.FC = () => {
    // Create a client
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
            },
        },
    });

    // disable horizontal swipe
    // disableHorizontalSwipe();

    return (
        <AppProvider>
            <UserInfoProvider>
                <QueryClientProvider client={queryClient}>
                    <Suspense fallback={<LinearLoader />}>
                        <RouterProvider router={getRouter()} />
                    </Suspense>
                </QueryClientProvider>
            </UserInfoProvider>
        </AppProvider>
    );
};

export default App;
